import { Box } from '@mui/material'
import * as React from 'react'
import ReactMarkdown from 'react-markdown'

/**
 * Renders a note's markdown body. react-markdown emits no raw HTML by default,
 * so a note file cannot inject markup; links open in a new tab.
 */
export const ReleaseNoteBody: React.FC<{ body: string }> = ({ body }) => (
  <Box
    sx={{
      '& p': { my: 1 },
      '& ul': { pl: 2.5, my: 1 },
      '& li': { mb: 0.75 },
      '& code': { fontFamily: 'monospace', fontSize: '0.9em' },
    }}
  >
    <ReactMarkdown
      components={{
        a: ({ node: _node, ...props }) => (
          <a {...props} target="_blank" rel="noopener noreferrer" />
        ),
      }}
    >
      {body}
    </ReactMarkdown>
  </Box>
)

export default ReleaseNoteBody
